// src/components/user/controltower/TowerHeader.jsx
import React from 'react';
import { AlertTriangle, ChevronLeft, Menu, PackageCheck, Route, X } from 'lucide-react';

export function TowerHeader({ setActiveComponent, showList, onToggleList, deliveryPoints, alertSummary }) {
  function count(status) {
    return deliveryPoints.filter(d => d.status === status).length;
  }

  const pills = [
    { label: 'Pendiente', value: count('pending'), color: 'bg-orange-100 text-orange-700' },
    { label: 'En camino', value: count('encamino'), color: 'bg-blue-100 text-blue-700' },
    { label: 'Entregado', value: count('entregado'), color: 'bg-green-100 text-green-700' },
  ];

  const activeCount = count('pending') + count('encamino');

  return (
    <div className="flex-shrink-0 bg-white border-b border-slate-200 shadow-sm z-30 safe-area-top">
      <div className="px-3 sm:px-4 py-2.5 sm:py-3">
        <div className="flex items-center justify-between gap-3 mb-2.5">
          <button
            onClick={() => setActiveComponent('Options')}
            className="flex items-center gap-1.5 text-slate-700 hover:text-brand-primary transition-colors font-montserrat min-w-0"
          >
            <ChevronLeft className="w-5 h-5 shrink-0" />
            <span className="text-sm hidden xs:inline">Volver</span>
          </button>

          <div className="text-center min-w-0">
            <h1 className="text-base sm:text-lg font-extrabold text-brand-primary font-montserrat italic leading-tight">
              Torre de Control
            </h1>
            <p className="hidden sm:block text-[11px] text-slate-500 font-montserrat">
              Visibilidad operativa de tus entregas
            </p>
          </div>

          <button
            onClick={onToggleList}
            className="p-2 text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors lg:hidden"
            aria-label={showList ? 'Ocultar lista' : 'Mostrar lista'}
          >
            {showList ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
          <div className="w-16 hidden lg:block" />
        </div>

        <div className="flex items-center gap-1.5 overflow-x-auto pb-0.5 no-scrollbar">
          <span className="inline-flex items-center gap-1 text-xs font-bold font-montserrat px-2 py-1 rounded-full bg-slate-900 text-white shrink-0">
            <PackageCheck className="w-3.5 h-3.5" />
            {deliveryPoints.length} total
          </span>

          <span className="inline-flex items-center gap-1 text-xs font-bold font-montserrat px-2 py-1 rounded-full bg-slate-100 text-slate-700 shrink-0">
            <Route className="w-3.5 h-3.5" />
            {activeCount} activas
          </span>

          {pills.map(p => p.value > 0 && (
            <span key={p.label} className={`text-xs font-semibold font-montserrat px-2 py-1 rounded-full shrink-0 ${p.color}`}>
              {p.label}: {p.value}
            </span>
          ))}

          {alertSummary?.total > 0 && (
            <span className={`inline-flex items-center gap-1 text-xs font-extrabold font-montserrat px-2 py-1 rounded-full shrink-0 ${alertSummary.high > 0 ? 'bg-red-100 text-red-700 animate-pulse' : 'bg-amber-100 text-amber-700'}`}>
              <AlertTriangle className="w-3.5 h-3.5" />
              {alertSummary.total} alerta{alertSummary.total !== 1 ? 's' : ''}
              {alertSummary.high > 0 ? ` - ${alertSummary.high} critica${alertSummary.high !== 1 ? 's' : ''}` : ''}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
